import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFlex,{attrs:{"xs12":""}},[_c(VContainer,{attrs:{"fluid":"","grid-list-lg":""}},[_c(VLayout,{attrs:{"column":"","wrap":""}},[_c(VLayout,{attrs:{"row":""}},[_vm._t("header")],2),_c(VLayout,{attrs:{"row":""}},[_c(VFlex,{attrs:{"xs12":"","d-flex":""}},[_vm._t("default")],2)],1),_c(VLayout,{staticClass:"footer",attrs:{"row":""}},[_vm._t("footer")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }